import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 统计数据
    statistics: {
      projects: 0,
      packages: 0,
      bidders: 0,
      bidRecords: 0
    },
    
    // 项目数据
    projects: [],
    projectsTotal: 0,
    
    // 包数据
    packages: [],
    packagesTotal: 0,
    
    // 投标记录数据
    bidRecords: [],
    bidRecordsTotal: 0,
    
    // 投标人数据
    bidders: [],
    biddersTotal: 0,
    
    // 选择状态
    selectedProjectId: null,
    selectedPackageId: null,
    selectedBidderId: null
  },
  
  mutations: {
    SET_STATISTICS(state, statistics) {
      state.statistics = statistics
    },
    
    SET_PROJECTS(state, { items, total }) {
      state.projects = items
      state.projectsTotal = total
    },
    
    SET_PACKAGES(state, { items, total }) {
      state.packages = items
      state.packagesTotal = total
    },
    
    SET_BID_RECORDS(state, { items, total }) {
      state.bidRecords = items
      state.bidRecordsTotal = total
    },
    
    SET_BIDDERS(state, { items, total }) {
      state.bidders = items
      state.biddersTotal = total
    },
    
    SET_SELECTED_PROJECT(state, projectId) {
      state.selectedProjectId = projectId
    },
    
    SET_SELECTED_PACKAGE(state, packageId) {
      state.selectedPackageId = packageId
    },
    
    SET_SELECTED_BIDDER(state, bidderId) {
      state.selectedBidderId = bidderId
    }
  },
  
  actions: {
    async loadStatistics({ commit }) {
      try {
        const response = await axios.get('/import/statistics')
        const data = response.data.data || response.data
        commit('SET_STATISTICS', data)
      } catch (error) {
        console.error('加载统计数据失败:', error)
      }
    },
    
    async loadProjects({ commit }, params = {}) {
      try {
        const response = await axios.get('/import/projects', { params })
        const data = response.data.data || response.data
        commit('SET_PROJECTS', { items: data.items, total: data.total })
      } catch (error) {
        console.error('加载项目列表失败:', error)
      }
    },
    
    async loadPackages({ commit }, params = {}) {
      try {
        const response = await axios.get('/import/packages', { params })
        const data = response.data.data || response.data
        commit('SET_PACKAGES', { items: data.items, total: data.total })
      } catch (error) {
        console.error('加载包列表失败:', error)
      }
    },
    
    async loadBidRecords({ commit }, params = {}) {
      try {
        const response = await axios.get('/import/bid-records', { params })
        const data = response.data.data || response.data
        commit('SET_BID_RECORDS', { items: data.items, total: data.total })
      } catch (error) {
        console.error('加载投标记录失败:', error)
      }
    },
    
    async loadBidders({ commit }, params = {}) {
      try {
        const response = await axios.get('/import/bidders', { params })
        const data = response.data.data || response.data
        commit('SET_BIDDERS', { items: data.items || data, total: data.total || data.length })
      } catch (error) {
        console.error('加载投标人列表失败:', error)
      }
    }
  }
})
